/*
 * Copyright © 2015-2020 Serenova, LLC. All rights reserved.
 */

import ContactAttributesDetailsPanel from './layout';

export default ContactAttributesDetailsPanel;
